// extracted by mini-css-extract-plugin
module.exports = {"zone":"ImageImport_zone__3O2wQ","background":"ImageImport_background__3jqom","placeholder":"ImageImport_placeholder__1q7dr","frame":"ImageImport_frame__13AZB"};